module.exports = __webpack_public_path__ + "img/庆祖镇-c.2734966f.png";